export default __webpack_public_path__ + "static/recruitee-747096c609b7b85fabac810be40ef1a5.png";